(function () {
  'use strict';

  if (window.ntProductVideo) {
    window.ntProductVideo.init();
    return;
  }

  var ROOT_SELECTOR = '[data-nt-video]';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function getVideo(root) {
    return root.querySelector('.nt-product-video__el');
  }

  function setState(root, state) {
    root.setAttribute('data-nt-state', state);
    var btn = root.querySelector('[data-nt-video-toggle]');
    if (!btn) return;
    var label = state === 'playing'
      ? root.getAttribute('data-nt-label-pause')
      : root.getAttribute('data-nt-label-play');
    if (label) btn.setAttribute('aria-label', label);
  }

  function play(root) {
    var video = getVideo(root);
    if (!video) return;
    if (video.preload !== 'auto') video.preload = 'auto';
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () { setState(root, 'paused'); });
    }
  }

  function pause(root) {
    var video = getVideo(root);
    if (video && !video.paused) video.pause();
  }

  function canAutoplay(root) {
    return root.hasAttribute('data-nt-autoplay') &&
      root.getAttribute('data-nt-user-paused') !== '1' &&
      !reduceMotion;
  }

  function resumeIfVisible(root) {
    if (root.getAttribute('data-nt-in-view') === '1' && canAutoplay(root)) play(root);
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      var root = entry.target;
      root.setAttribute('data-nt-in-view', entry.isIntersecting ? '1' : '0');
      if (entry.isIntersecting) {
        if (canAutoplay(root)) play(root);
      } else {
        pause(root);
      }
    });
  }

  function bindRoot(root) {
    if (root.getAttribute('data-nt-ready') === '1') return;
    root.setAttribute('data-nt-ready', '1');

    var video = getVideo(root);
    if (!video) return;

    video.addEventListener('playing', function () { setState(root, 'playing'); });
    video.addEventListener('pause', function () { setState(root, 'paused'); });

    if (observer) {
      observer.observe(root);
    } else if (canAutoplay(root)) {
      play(root);
    }
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(bindRoot);
  }

  function toggle(root) {
    var video = getVideo(root);
    if (!video) return;
    if (video.paused) {
      root.removeAttribute('data-nt-user-paused');
      play(root);
    } else {
      root.setAttribute('data-nt-user-paused', '1');
      pause(root);
    }
  }

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(onIntersect, { threshold: 0.25 });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-nt-video-toggle], .nt-product-video__el');
    if (!trigger) return;
    var root = trigger.closest(ROOT_SELECTOR);
    if (!root) return;
    e.preventDefault();
    toggle(root);
  });

  /* Galeri yeniden sıralandığında (DOM taşıma) oynatma kesilebilir */
  document.addEventListener('nt:product-video:moved', function () {
    document.querySelectorAll(ROOT_SELECTOR).forEach(resumeIfVisible);
  });

  /* Ürün görsel modalı kapanınca tema pauseAllMedia() ile tüm videoları durdurur */
  function watchProductModals() {
    document.querySelectorAll('product-modal').forEach(function (modal) {
      if (modal.getAttribute('data-nt-video-watch') === '1') return;
      modal.setAttribute('data-nt-video-watch', '1');
      new MutationObserver(function () {
        if (modal.hasAttribute('open')) return;
        setTimeout(function () {
          document.querySelectorAll(ROOT_SELECTOR).forEach(resumeIfVisible);
        }, 60);
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    });
  }

  document.addEventListener('shopify:section:load', function () {
    init();
    watchProductModals();
  });

  window.ntProductVideo = { init: init };

  function ready() {
    init();
    watchProductModals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
